import { SvgIcon } from "@mui/material";
import React from "react";

const IconTechSupport = (props: { style: React.CSSProperties }) => {
  return (
    <SvgIcon
      style={props.style}
      viewBox="0 0 160 160"
      className={" circular-chart"}
    >
      <svg
        width="160"
        height="167"
        viewBox="0 0 160 167"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.732422"
          y="8.03387"
          width="158.966"
          height="158.966"
          rx="79.483"
          fill="url(#paint0_linear_3733_2914)"
        />
        <mask
          id="mask0_3733_2914"
          maskUnits="userSpaceOnUse"
          x="0"
          y="8"
          width="160"
          height="159"
        >
          <rect
            x="0.731445"
            y="8.03387"
            width="158.966"
            height="158.966"
            rx="79.483"
            fill="url(#paint1_linear_3733_2914)"
          />
        </mask>
        <g mask="url(#mask0_3733_2914)">
          <path
            d="M19.8154 161.634C19.8154 119.137 26.3897 96.5287 36.7227 84.5083C46.9633 72.5952 61.194 70.7499 77.7541 70.7499C94.3141 70.7499 108.544 72.5952 118.783 84.5082C129.115 96.5286 135.688 119.137 135.688 161.634V189.436H19.8154V161.634Z"
            fill="white"
            stroke="#313334"
            stroke-width="3"
          />
        </g>
        <mask id="path-4-inside-1_3733_2914" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M87.8266 62.9991C97.2966 58.7648 104 48.2727 104 36C104 19.9837 92.5833 7 78.5 7C64.4167 7 53 19.9837 53 36C53 47.2445 58.6273 56.9943 66.854 61.8058C67.3186 62.5678 67.6269 63.1774 67.6287 63.4808C67.6287 69.1402 63.8857 70.6952 60.6185 72.0525C58.0884 73.1036 55.8438 74.0361 55.8438 76.6643C55.8438 82.2348 64.5003 84.2422 78.1264 84.2422C87.7859 84.2422 100.414 82.2298 100.414 76.6643C100.414 74.3164 98.0692 73.2969 95.4035 72.1379C91.8929 70.6116 87.8259 68.8435 87.8259 63.4808C87.8259 63.3176 87.8261 63.157 87.8266 62.9991Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M87.8266 62.9991C97.2966 58.7648 104 48.2727 104 36C104 19.9837 92.5833 7 78.5 7C64.4167 7 53 19.9837 53 36C53 47.2445 58.6273 56.9943 66.854 61.8058C67.3186 62.5678 67.6269 63.1774 67.6287 63.4808C67.6287 69.1402 63.8857 70.6952 60.6185 72.0525C58.0884 73.1036 55.8438 74.0361 55.8438 76.6643C55.8438 82.2348 64.5003 84.2422 78.1264 84.2422C87.7859 84.2422 100.414 82.2298 100.414 76.6643C100.414 74.3164 98.0692 73.2969 95.4035 72.1379C91.8929 70.6116 87.8259 68.8435 87.8259 63.4808C87.8259 63.3176 87.8261 63.157 87.8266 62.9991Z"
          fill="#DEB59E"
        />
        <path
          d="M87.8266 62.9991L86.602 60.2604L84.8318 61.0519L84.8266 62.9909L87.8266 62.9991ZM66.854 61.8058L69.4154 60.2439L69.0216 59.5981L68.3686 59.2162L66.854 61.8058ZM67.6287 63.4808H70.6287V63.4718L70.6286 63.4628L67.6287 63.4808ZM60.6185 72.0525L61.7695 74.8229L61.7695 74.8229L60.6185 72.0525ZM95.4035 72.1379L96.5996 69.3867H96.5996L95.4035 72.1379ZM101 36C101 47.2223 94.8757 56.561 86.602 60.2604L89.0511 65.7378C99.7174 60.9686 107 49.323 107 36H101ZM78.5 10C90.5755 10 101 21.2664 101 36H107C107 18.7011 94.591 4 78.5 4V10ZM56 36C56 21.2664 66.4245 10 78.5 10V4C62.409 4 50 18.7011 50 36H56ZM68.3686 59.2162C61.1384 54.9875 56 46.2705 56 36H50C50 48.2186 56.1163 59.0012 65.3394 64.3954L68.3686 59.2162ZM70.6286 63.4628C70.6233 62.5775 70.2573 61.8079 70.1258 61.5304C69.9252 61.1072 69.6704 60.6622 69.4154 60.2439L64.2926 63.3676C64.3937 63.5334 64.4796 63.68 64.5506 63.8073C64.6225 63.9363 64.6721 64.0329 64.704 64.1002C64.7389 64.1738 64.7362 64.1779 64.7199 64.1279C64.7109 64.1004 64.6915 64.0373 64.673 63.9456C64.6554 63.8582 64.63 63.7026 64.6287 63.4989L70.6286 63.4628ZM61.7695 74.8229C63.3091 74.1833 65.5947 73.2692 67.4055 71.5639C69.3898 69.6952 70.6287 67.0834 70.6287 63.4808H64.6287C64.6287 65.5376 63.996 66.533 63.292 67.1959C62.4146 68.0222 61.1951 68.5643 59.4676 69.282L61.7695 74.8229ZM58.8438 76.6643C58.8438 76.4552 58.883 76.3909 58.8869 76.3835C58.8985 76.3616 58.9496 76.273 59.1419 76.1212C59.6272 75.7378 60.3909 75.3956 61.7695 74.8229L59.4676 69.282C58.3161 69.7604 56.6923 70.41 55.4229 71.4128C53.9503 72.5759 52.8438 74.2839 52.8438 76.6643H58.8438ZM78.1264 81.2422C71.3806 81.2422 66.1827 80.736 62.7631 79.6766C61.058 79.1483 60.0339 78.5529 59.4736 78.0216C58.998 77.5706 58.8438 77.1692 58.8438 76.6643H52.8438C52.8438 78.9447 53.7716 80.8832 55.3449 82.3752C56.8336 83.787 58.8252 84.7379 60.9875 85.4078C65.3028 86.7447 71.2461 87.2422 78.1264 87.2422V81.2422ZM97.4142 76.6643C97.4142 76.751 97.4132 77.1242 96.525 77.7706C95.6097 78.4366 94.1239 79.091 92.0981 79.6475C88.084 80.75 82.8029 81.2422 78.1264 81.2422V87.2422C83.1094 87.2422 88.9723 86.7282 93.6872 85.4332C96.0259 84.7908 98.3009 83.8987 100.055 82.6221C101.837 81.3258 103.414 79.3604 103.414 76.6643H97.4142ZM94.2074 74.8891C95.6424 75.5131 96.5264 75.9164 97.1024 76.3507C97.3497 76.5371 97.4156 76.6425 97.4214 76.6523C97.4226 76.6543 97.4173 76.645 97.4135 76.6308C97.4097 76.6168 97.4142 76.6239 97.4142 76.6643H103.414C103.414 74.2581 102.119 72.6185 100.715 71.5598C99.4517 70.6077 97.8303 69.9218 96.5996 69.3867L94.2074 74.8891ZM84.8259 63.4808C84.8259 67.0698 86.2477 69.6482 88.2972 71.4831C90.1767 73.1659 92.5417 74.165 94.2074 74.8891L96.5996 69.3867C94.7546 68.5846 93.3309 67.9365 92.2993 67.0129C91.4377 66.2415 90.8259 65.2545 90.8259 63.4808H84.8259ZM84.8266 62.9909C84.8261 63.152 84.8259 63.3153 84.8259 63.4808H90.8259C90.8259 63.3199 90.8261 63.1621 90.8265 63.0072L84.8266 62.9909Z"
          fill="#313334"
          mask="url(#path-4-inside-1_3733_2914)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M78.8704 0.01835C81.3343 0.0917499 82.9412 0.287484 84.8962 0.75235C86.3692 1.09488 88.6724 1.85335 89.9847 2.44055C91.297 3.02775 93.3592 4.17768 94.5375 4.96061C95.7159 5.76801 97.4567 7.18708 98.3673 8.11681C99.3046 9.04655 100.59 10.5145 101.233 11.3953C101.876 12.2761 102.84 13.8665 103.402 14.943C103.938 16.0195 104.688 17.9524 105.063 19.2247C105.571 21.0352 105.759 22.3809 106 29.1337L105.277 29.8677C104.875 30.2836 104.554 30.6751 104.581 30.7729C104.581 30.8953 104.5 30.9687 104.366 30.9687C104.259 30.9687 103.991 30.6261 103.777 30.1857C103.563 29.7453 103 29.2071 102.572 28.9624C102.143 28.7422 101.313 28.4975 100.751 28.4241C100.215 28.3263 99.1975 28.0327 98.4744 27.7391C97.7781 27.421 96.7068 26.7115 96.0641 26.1487C95.4481 25.5615 94.6982 24.6563 94.4036 24.118C94.109 23.5797 93.627 23.0415 93.3324 22.8947C93.0378 22.7479 92.5825 22.6989 92.3147 22.7479C92.0736 22.8213 91.1363 23.6776 90.2525 24.6563C89.3687 25.6349 87.7351 27.2497 86.637 28.2284C85.539 29.2315 83.7982 30.6017 82.7537 31.3112C81.7092 32.0207 80.0488 33.0973 79.0043 33.66C77.9598 34.2472 76.1655 35.128 74.9871 35.6173C73.8087 36.1311 71.693 36.8651 70.3003 37.2811C68.9077 37.6725 66.5509 38.2108 65.078 38.4555C63.605 38.6757 60.659 38.8959 58.5165 38.9448C56.374 38.9937 54.4189 39.0182 54.1243 39.0182C53.8565 39.0427 53.1602 39.4831 52.571 40.0213C51.9818 40.5596 51.9463 41 51.9196 41C51.9196 41 50.9509 39.3007 50.616 36.7322C50.3593 34.1667 50.3593 33.5972 50.1071 31.3112C50 30.75 50.0002 30.4054 50.0002 28.1992L50 25.586C50.1071 23.6287 50.3482 21.2554 50.5624 20.3257C50.8034 19.3959 51.3659 17.6343 51.8479 16.411C52.3568 15.1877 53.4012 13.2548 54.2315 12.0559C55.0349 10.8815 56.4275 9.16888 57.3381 8.26361C58.2219 7.35835 59.9627 5.91481 61.2214 5.05848C62.4534 4.20215 64.5691 3.02775 65.8814 2.44055C67.1937 1.85335 69.2023 1.16828 70.3003 0.874683C71.3984 0.60555 73.032 0.287483 73.9158 0.16515C74.7996 0.0183502 77.0225 -0.0305833 78.8704 0.01835Z"
          fill="#313334"
        />
        <rect
          x="98.5"
          y="26.5"
          width="11"
          height="17"
          rx="5.5"
          fill="#7E509A"
          stroke="#7E509A"
        />
        <rect
          x="46.5"
          y="26.5"
          width="11"
          height="17"
          rx="5.5"
          fill="#7E509A"
          stroke="#7E509A"
        />
        <path
          d="M79.0608 56.1362C76.699 56.1274 74.4135 55.2993 72.5943 53.7932C72.4332 53.6661 72.2988 53.5085 72.1987 53.3293C72.0985 53.1502 72.0346 52.9531 72.0107 52.7493C71.9867 52.5455 72.0032 52.339 72.0591 52.1416C72.115 51.9441 72.2093 51.7596 72.3365 51.5987C72.5944 51.2745 72.9706 51.0662 73.3821 51.0193C73.7937 50.9724 74.2069 51.091 74.5311 51.3488C79.2169 55.035 83.6684 51.5128 83.8559 51.3488C84.1771 51.0883 84.5887 50.9658 85.0001 51.0083C85.4115 51.0507 85.7892 51.2546 86.0505 51.5752C86.3118 51.8955 86.4356 52.3063 86.3946 52.7177C86.3536 53.129 86.1512 53.5074 85.8318 53.7698C83.8977 55.2842 81.5171 56.1163 79.0608 56.1362Z"
          fill="#313334"
        />
        <path
          d="M106.852 38C106.852 38 106.406 46.8049 102.5 50C98.5954 53.1951 93.218 51.8213 93.218 51.8213"
          stroke="#7E509A"
          stroke-width="2"
        />
        <circle cx="92" cy="52" r="2.5" fill="#7E509A" stroke="#7E509A" />
        <path
          d="M78 3.03774C63.9963 3.03774 52.5821 14.1249 52.0566 28H52.0189C52.5444 14.104 63.9754 3 78 3C92.0246 3 103.456 14.104 103.981 28H103.943C103.418 14.1249 92.0037 3.03774 78 3.03774Z"
          fill="#7E509A"
          stroke="#7E509A"
          stroke-width="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3733_2914"
            x1="80.2155"
            y1="8.03387"
            x2="80.2155"
            y2="167"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E1F4FA" />
            <stop offset="1" stop-color="#C4E9F5" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3733_2914"
            x1="80.2145"
            y1="8.03387"
            x2="80.2145"
            y2="167"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E1F4FA" />
            <stop offset="1" stop-color="#C4E9F5" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default IconTechSupport;
